module.exports = __webpack_public_path__ + "img/34.87b40496.jpg";